import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import noop from 'lodash/fp/noop';
import classNames from 'classnames';
import Collapse from '../collapse/Collapse';
const ExpanderPanel = (props) => {
    const { open = false, iconLeft = false, bsStyle = 'blank', title, headerClassName, titleClassName, bodyClassName, iconClassName, unmountOnExit = true, onEntered = noop, onExited = noop, onAnimationStart = noop, onToggle = noop, className, children, ...remainingProps } = props;
    const [isOpen, setIsOpen] = useState(open);
    // Update internal state from external prop change
    const [previousOpen, setPreviousOpen] = useState(open);
    if (previousOpen !== open) {
        setIsOpen(open);
        setPreviousOpen(open);
    }
    const handleToggle = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        onToggle(newState);
    };
    const wrapperClassNames = classNames('expander-panel panel', `panel-${bsStyle}`, className);
    const iconClassNames = classNames('expander-icon', iconClassName, 'rioglyph', 'rioglyph-chevron-down');
    const headerClassNames = classNames('panel-heading', isOpen && 'open', iconLeft && 'icon-left', headerClassName && headerClassName);
    const titleClassNames = classNames('title', titleClassName && titleClassName);
    const bodyClassNames = classNames('panel-body', bodyClassName && bodyClassName);
    const isRenderCallback = children && typeof children === 'function';
    return (_jsxs("div", { ...remainingProps, className: wrapperClassNames, "aria-label": 'expander panel', children: [_jsxs("div", { className: headerClassNames, onClick: handleToggle, "aria-label": 'panel heading', children: [_jsx("span", { className: titleClassNames, children: title }), _jsx("span", { className: iconClassNames }), bsStyle === 'separator' && (_jsx("div", { className: 'separator', children: _jsx("hr", {}) }))] }), _jsx(Collapse, { open: isOpen, unmountOnExit: unmountOnExit, onEntered: onEntered, onExited: onExited, onAnimationStart: () => onAnimationStart(), children: _jsx("div", { children: _jsx("div", { className: bodyClassNames, children: isRenderCallback ? children(isOpen) : children }) }) })] }));
};
export default ExpanderPanel;
